import type { LoginResponse } from 'src/requests/user';

const RNToWebMessageTypes = {
  COLLABORATE_OPEN_MENU: 'COLLABORATE_OPEN_MENU',
  AUTH_DATA: 'AUTH_DATA',
  CHANGE_WORKSPACE: 'CHANGE_WORKSPACE',
  LOGOUT: 'LOGOUT',
} as const;

type RNToWebMessageTypes = typeof RNToWebMessageTypes;

const WebToRNMessageTypes = {
  READY: 'READY',
} as const;

type WebToRNMessageTypes = typeof WebToRNMessageTypes;

export const MessagesTypes = {
  ...RNToWebMessageTypes,
  ...WebToRNMessageTypes,
} as const;

type RNToWebMessageGeneric = {
  type: RNToWebMessageTypes[keyof RNToWebMessageTypes];
};

export type RNToWebAuthDataMessagePayload = LoginResponse & {
  lastLocation: string;
};

type RNToWebAuthDataMessage = {
  type: RNToWebMessageTypes['AUTH_DATA'];
  payload: RNToWebAuthDataMessagePayload;
};

type RNToWebChangeWorkspaceMessage = {
  type: RNToWebMessageTypes['CHANGE_WORKSPACE'];
  payload: {
    userId: string;
  };
};

export type NativeToWebMessage =
  | RNToWebMessageGeneric
  | RNToWebAuthDataMessage
  | RNToWebChangeWorkspaceMessage;

export type WebToNativeMessage = {
  type: WebToRNMessageTypes[keyof WebToRNMessageTypes];
};

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}
